/** Cloud-based map ID required for AdvancedMarkerElement. Safe for development. */
export const GOOGLE_MAP_ID = 'DEMO_MAP_ID';

export const MAPS_REFERRER_ERROR =
  'This Google Maps key is not allowed for this site. In Google Cloud Console → Credentials, add http://localhost:5173/* (and your live admin URL) to the key HTTP referrers.';

export type MapOverlay = {
  setMap?: (map: unknown | null) => void;
  map?: unknown | null;
};

export function pinElement(color: string, kind?: string): HTMLDivElement {
  const size = kind === 'current' ? 16 : 14;
  const el = document.createElement('div');
  el.style.cssText = [
    `width:${size}px`,
    `height:${size}px`,
    'border-radius:50%',
    `background:${color}`,
    'border:3px solid #fff',
    'box-shadow:0 2px 8px rgba(0,0,0,.35)',
    kind === 'current' ? 'animation:pulse 2s infinite' : '',
  ].filter(Boolean).join(';');
  return el;
}

export function addMapPin(
  map: unknown,
  opts: { lat: number; lng: number; title?: string; color?: string; kind?: string },
): MapOverlay {
  const g = (window as unknown as {
    google: {
      maps: {
        Marker: new (o: Record<string, unknown>) => MapOverlay;
        SymbolPath: { CIRCLE: unknown };
        marker?: {
          AdvancedMarkerElement: new (o: Record<string, unknown>) => MapOverlay;
        };
      };
    };
  }).google;

  const position = { lat: opts.lat, lng: opts.lng };
  const Advanced = g.maps.marker?.AdvancedMarkerElement;
  if (Advanced) {
    return new Advanced({
      map,
      position,
      title: opts.title,
      content: pinElement(opts.color || '#2563eb', opts.kind),
    });
  }

  return new g.maps.Marker({
    map,
    position,
    title: opts.title,
    icon: opts.color
      ? {
          path: g.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: opts.color,
          fillOpacity: 1,
          strokeColor: '#fff',
          strokeWeight: 2,
        }
      : undefined,
  });
}

export function clearMapOverlay(item: MapOverlay | null | undefined) {
  if (!item) return;
  if (typeof item.setMap === 'function') item.setMap(null);
  else item.map = null;
}
